import { AbsRemixPage } from '@lemon8/web-app-shared/ssr';
import { useAtomValue } from 'jotai';
import { Loading } from '~/components/loading';
import { $LegalPageLevelTraffic } from 'shared/atoms/common/legal-page-level-traffic';

import './style.scss';

export abstract class LegalRemixPage extends AbsRemixPage {
  HeadSkeleton = () => {
    return (
      <>
        <title>Lemon8 Loading...</title>
      </>
    );
  };
  BodySkeleton = () => {
    return (
      <div className="full-screen-layout">
        <Loading variant="ball" />
      </div>
    );
  };

  useRouteLoading = () => {
    const { canonicalUrl } = useAtomValue($LegalPageLevelTraffic);

    if (__BUILD_TARGET__ === 'server') {
      return false;
    }

    const a = new URL(canonicalUrl);
    return location.pathname !== a.pathname;
  };
}
